import { Route } from '@angular/router';
import { TemplateGroupsComponent } from '../../../../../pages/media/templateGroup/template-groups.component';
import { TemplateGroupEditComponent } from '../../../../../pages/media/templateGroup/templateGroup-edit/template-group-edit.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const templateGroups: Route = {
  path: 'template-group',
  title: 'nav.templateGroup',
  data: {
    id: RoutingID.templateGroups,
    breadcrumb: 'nav.templateGroup',
    icon: SbIcons.templates,
  },

  children: [
    {
      path: '',
      component: TemplateGroupsComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'template-group-edit/:templateGroupID',
      title: 'nav.templateGroup.details',
      data: {
        breadcrumb: 'nav.templateGroup.details',
        icon: SbIcons.details,
        id: RoutingID.templateGroupsEdit,
      },
      children: [
        {
          path: '',
          component: TemplateGroupEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'template-group-create',
      title: 'nav.templateGroup.create',
      data: {
        breadcrumb: 'nav.templateGroup.create',
        icon: SbIcons.plus,
        id: RoutingID.templateGroupsCreate,
      },
      children: [
        {
          path: '',
          component: TemplateGroupEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
